/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_Drizzle_LightInputs */

const en_ui_weather_drizzle_light = /** @type {(inputs: Ui_Weather_Drizzle_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Light drizzle`)
};

const de_ui_weather_drizzle_light = /** @type {(inputs: Ui_Weather_Drizzle_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leichter Nieselregen`)
};

/**
* | output |
* | --- |
* | "Light drizzle" |
*
* @param {Ui_Weather_Drizzle_LightInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_drizzle_light = /** @type {((inputs?: Ui_Weather_Drizzle_LightInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_Drizzle_LightInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_drizzle_light(inputs)
	return de_ui_weather_drizzle_light(inputs)
});